<template>

  <v-flex v-if="planDetails && planDetails.name === 'Hold'" d-flex xs12 sm6 md4 lg3 xl3>
    <v-card xs4 color="white" class="card-border text-xs-left">
      <v-system-bar height="45" window color="itoviPrimary">
        <h2 class="card-header-text">Activate Your Account</h2>
        <v-spacer></v-spacer>
      </v-system-bar>

      <ManagePlanDialog v-model="showManagePlanDialog" :plan="planDetails" />

      <div class="card-body">
        <div class="text-xs-center pt-2">
          <img src="../../assets/itovi-scanner.png" height="111" />
          <div class="text pt-1 pb-3">Activate your account and start<br>scanning again today!</div>
          <v-btn class="button" round color="accent" @click="openManagePlanDialog()">
            Activate Account
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-flex>
</template>

<style lang="scss" scoped>
.button {
  text-transform: none;
  font-weight: 600;
  font-size: 16px;
  height: 46px;
  padding: 0 28px;
}
.text {
  color: #717171;
}
</style>

<script>
  import store from "@/store";
  import ManagePlanDialog from "./yourPlanCard/ManagePlanDialog";
  import subscribeToStore from "@/mixins/subscribeToStore";

  export default {
    components: {
      ManagePlanDialog
    },
    data: ()=> ({
      planDetails: store.state.planDetails,
      showManagePlanDialog: false,
    }),
    props: {
      onLoaded: Function,
    },
    mixins: [subscribeToStore],
    created(){},
    mounted() {
      this.subscribeToStore(['planDetails']);
    },
    methods: {
      openManagePlanDialog() {
        store.commit("setShowManagePlanDialog", true);
      }
    },
  }
</script>
